import { useSetAtom } from 'jotai';
import React, { useCallback } from 'react';
import { MarginProps } from 'styled-system';

import { ActionButton } from '~/components/partials/ReceptionDrawer/ActionButton';
import { cancelDraftAppointmentPane } from '~/state/reception/atoms';

export const CancelButton = (props: MarginProps) => {
  const setCancelDraftAppointmentPane = useSetAtom(cancelDraftAppointmentPane);
  const handleClick = useCallback(() => {
    setCancelDraftAppointmentPane({
      isOpen: true,
    });
  }, [setCancelDraftAppointmentPane]);

  return (
    <ActionButton use="bgGrey" size="s" onClick={handleClick} {...props}>
      キャンセル
    </ActionButton>
  );
};
